import React from 'react';
import { View, Text, TextInput, StyleSheet, TextInputProps } from 'react-native';
import { ADMIN_COLORS } from '@/constants/admin';

interface FormInputProps extends TextInputProps {
  label: string;
  error?: string;
  required?: boolean;
}

export const FormInput: React.FC<FormInputProps> = ({
  label,
  error,
  required = false,
  style,
  ...props
}) => {
  return (
    <View style={styles.container}>
      <Text style={styles.label}>
        {label}{required && <Text style={styles.required}> *</Text>}
      </Text>
      <TextInput
        style={[
          styles.input,
          error && styles.inputError,
          props.multiline && styles.textArea,
          style,
        ]}
        placeholderTextColor={ADMIN_COLORS.TEXT_TERTIARY}
        {...props}
      />
      {error && <Text style={styles.errorText}>{error}</Text>}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    marginBottom: 16,
  },
  label: {
    fontSize: 14,
    fontWeight: '500',
    color: ADMIN_COLORS.TEXT_SECONDARY,
    marginBottom: 8,
  },
  required: {
    color: ADMIN_COLORS.ERROR,
  },
  input: {
    backgroundColor: ADMIN_COLORS.BACKGROUND.SECONDARY,
    borderRadius: 8,
    paddingHorizontal: 16,
    paddingVertical: 12,
    fontSize: 16,
    color: ADMIN_COLORS.TEXT_PRIMARY,
    borderWidth: 1,
    borderColor: ADMIN_COLORS.BORDER,
    minHeight: 48,
  },
  textArea: {
    minHeight: 120,
    textAlignVertical: 'top',
    paddingTop: 12,
  },
  inputError: {
    borderColor: ADMIN_COLORS.ERROR,
  },
  errorText: {
    fontSize: 12,
    color: ADMIN_COLORS.ERROR,
    marginTop: 4,
  },
});
